/* Natural Rugs custom-size calculator. Markup: snippets/nr-calc-ui.liquid */
/* Checkout: each custom rug is added as ONE item at its exact price, using the hidden
   "custom-rug-p1" … "custom-rug-p8" products (one variant per $5 price, $200–$10,000). */
(function () {
  if (window.__nrCalc) return;
  window.__nrCalc = true;

  var X = '×';
  var MIN_SHORT = 60, MIN_LONG = 80;               /* smallest rug: 60 × 80 cm */
  var P_MIN = 200, P_MAX = 10000, P_STEP = 5, PER_BAND = 250, P_HANDLE = 'custom-rug-p';
  var LEAD = 'Made to order in about 3 weeks, then 5–10 business days delivery to most capitals';
  var LS_KEY = 'nr_calc_last';

  function track(name, data) {
    data = data || {};
    try { if (window.dataLayer) window.dataLayer.push(Object.assign({ event: name }, data)); } catch (e) {}
    try { if (window.gtag) window.gtag('event', name, data); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, data); } catch (e) {}
  }
  function money(n) { return '$' + n.toLocaleString('en-AU'); }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function folded(v) { return /^folded/i.test(v); }
  function isCustomHandle(h) { return typeof h === 'string' && h.indexOf('custom-rug') === 0; }
  function lsGet() { try { return JSON.parse(localStorage.getItem(LS_KEY) || 'null'); } catch (e) { return null; } }
  function lsSet(v) { try { localStorage.setItem(LS_KEY, JSON.stringify(v)); } catch (e) {} }

  /* Short, plain-English notes for each finish (from the Rug Finishes guide). */
  var CDN = 'https://cdn.shopify.com/s/files/1/0527/5074/5800/files/';
  function finishInfo(v, root) {
    if (/black/i.test(v) && /bind/i.test(v)) return { d: 'Black cotton binding: a woven border sewn around the edge for a defined, classic frame. Latex backing.', i: root.dataset.imgBlack };
    if (/jute/i.test(v) && /bind/i.test(v)) return { d: 'Natural jute binding: a woven border that blends with the weave for a tailored edge. Latex backing.', i: root.dataset.imgJute };
    if (/bind/i.test(v)) return { d: 'Binding: a woven border sewn around the edge for a defined, tailored frame. Latex backing.', i: CDN + 'Binding_720x_0df2cede-7e16-4171-9072-2caf7342b9d0.webp' };
    if (folded(v) && /underlay/i.test(v)) return { d: 'Folded edge with underlay: the weave is folded under for a clean, seamless edge, with an underlay backing that makes it thicker and softer underfoot (about 2 cm). Best for living rooms and bedrooms.', i: CDN + 'Smooth_720x_7069bf70-508b-473b-8ea1-1268b8ae772d.webp' };
    if (folded(v)) return { d: 'Folded edge: the weave is folded under around the edge for a clean, seamless border.', i: CDN + 'Smooth_720x_7069bf70-508b-473b-8ea1-1268b8ae772d.webp' };
    if (/selvedge/i.test(v)) return { d: 'Selvedge and tuck: keeps the natural woven edge on two sides, with a small 1–2 cm fringe. A relaxed, natural look. Latex backing.', i: CDN + 'vtlkasak_720x_2f4da1d4-e37f-4cb2-9b49-5971f2759e66.webp' };
    if (/overlock/i.test(v)) return { d: 'Overlock: a neat stitched edge that keeps the focus on the weave. Simple, durable and low-profile. Latex backing.', i: CDN + 'IMG_3136_529c41f5-b637-43de-b584-96a602c25e1b.jpg' };
    return null;
  }

  /* Price one rug. Returns {err} or {rug, runner, seams}. W/L in cm. */
  function price(rate, shape, W, L, finish) {
    if (shape === 'round') L = W;
    if (!(W > 0 && L > 0)) return { err: 'size' };
    var s = Math.min(W, L), g = Math.max(W, L);
    if (s < MIN_SHORT || g < MIN_LONG) return { err: 'min' };
    var runner = shape !== 'round' && s <= 100 && g >= 250;
    var seams = s > 400 ? Math.ceil(s / 400) - 1 : 0;
    var a = (W / 100) * (L / 100);
    var base = (a * rate + ((W + L) / 100) * 2 * 35 + (folded(finish) ? a * 15 : 0)) * 1.5;
    if (shape === 'round') base *= 1.1;
    else if (runner) base *= g > 800 ? 1.2 : 1.1;
    return { rug: Math.ceil(Math.round(base * 1e6) / 1e6 / 10) * 10, runner: runner, seams: seams, area: a };
  }
  window.NRCustomPrice = price;

  /* Find the variant that charges exactly this price (one item, × 1 at checkout). */
  var bandCache = {};
  function priceVariant(total) {
    if (total < P_MIN || total > P_MAX || total % P_STEP !== 0) return Promise.reject(new Error('range'));
    var band = Math.floor((total - P_MIN) / P_STEP / PER_BAND) + 1;
    var handle = P_HANDLE + band;
    var p = bandCache[handle] || (bandCache[handle] = fetch('/products/' + handle + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw r; return r.json(); }));
    return p.then(function (prod) {
      var cents = Math.round(total * 100);
      for (var i = 0; i < prod.variants.length; i++) {
        if (prod.variants[i].price === cents && prod.variants[i].available !== false) return prod.variants[i].id;
      }
      throw new Error('no variant');
    }).catch(function (e) { delete bandCache[handle]; throw e; });
  }

  function urlCfg() {
    var m = /[?&]nrc=([^&#]+)/.exec(location.search);
    if (!m) return null;
    try { return JSON.parse(decodeURIComponent(m[1])); } catch (e) { return null; }
  }

  function init(root) {
    if (root.__nr) return;
    root.__nr = true;
    var $ = function (s) { return root.querySelector(s); };
    var mode = root.dataset.mode, trade = mode === 'trade';
    var tradeOff = parseFloat(root.dataset.tradeOff) || 0;
    var qForm = document.getElementById(root.dataset.uid);
    var rs = $('[data-rug]'), shape = $('[data-shape]'), w = $('[data-w]'), l = $('[data-l]');
    var lWrap = $('[data-l-wrap]'), wLab = $('[data-w-label]'), fin = $('[data-finish]'), care = $('[data-care]');
    var finWrap = $('[data-fin-wrap]'), shapeWrap = $('[data-shape-wrap]');
    var finInfo = $('[data-fin-info]'), thumb = $('[data-thumb]');
    var TILE_FINISH = 'Pre-finished squares (no edging needed)';
    function finishVal() { return rug && rug.s ? TILE_FINISH : fin.value; }
    var msg = $('[data-msg]'), out = $('[data-price]'), btn = $('[data-nr-add]');
    var qOpen = $('[data-quote-open]'), qDone = $('[data-quote-done]');
    var view = $('[data-view]'), viewWrap = $('[data-view-wrap]');
    var rugs = [], rug = null, cur = null, shownPrice = false, setMode = null;
    var wantFin = null;   /* the finish the customer chose; restored whenever the size allows it */

    if (mode === 'product') {
      rug = { t: root.dataset.rug, r: parseFloat(root.dataset.rate), u: root.dataset.url, i: root.dataset.img, s: parseFloat(root.dataset.tile) || 0 };
      wantFin = fin.value;
    } else {
      try { rugs = JSON.parse($('[data-rugs]').textContent); } catch (e) { rugs = []; }
      rugs.sort(function (a, b) { return a.t.localeCompare(b.t); });
      ['Sisal', 'Seagrass', 'Wool', 'Jute', 'Other'].forEach(function (m) {
        var g = document.createElement('optgroup'); g.label = m + ' rugs';
        rugs.forEach(function (r, i) {
          if (r.m === m) { var o = document.createElement('option'); o.value = i; o.textContent = r.t; g.appendChild(o); }
        });
        if (g.children.length) rs.appendChild(g);
      });
    }

    /* Placement */
    if (mode === 'product') {
      var form = root.previousElementSibling;
      while (form && form.tagName !== 'FORM') form = form.previousElementSibling;
      if (form) {
        var tabs = document.createElement('div');
        tabs.className = 'nr-tabs'; tabs.setAttribute('role', 'tablist');
        tabs.innerHTML = '<button type="button" role="tab" aria-selected="true" data-mode="std">Standard sizes</button>' +
          '<button type="button" role="tab" aria-selected="false" data-mode="custom">Custom size</button>';
        form.insertBefore(tabs, form.firstChild);
        form.insertBefore(root, tabs.nextSibling);
        if (qForm) form.parentNode.insertBefore(qForm, form.nextSibling);
        var meta = form.closest('.product-single__meta') || document;
        var prices = meta.querySelectorAll('.product__price,.product__unit-price,.product__price-savings');
        setMode = function (custom) {
          form.classList.toggle('nr-mode-custom', custom);
          if (qForm) qForm.classList.toggle('nr-quote--off', !custom);
          tabs.querySelectorAll('button').forEach(function (x) {
            x.setAttribute('aria-selected', String((x.dataset.mode === 'custom') === custom));
          });
          prices.forEach(function (p) { p.classList.toggle('nr-price-hide', custom); });
        };
        setMode(false);
        tabs.addEventListener('click', function (e) {
          var b = e.target.closest('button[data-mode]'); if (!b) return;
          var custom = b.dataset.mode === 'custom';
          setMode(custom);
          if (custom) { track('nr_calc_open', { rug: rug.t }); w.focus({ preventScroll: true }); }
        });
      }
    } else if (mode === 'page') {
      var anchor = document.querySelector('.rte .page-button-wrapper');
      if (anchor) anchor.parentNode.insertBefore(root, anchor.nextSibling);
      if (qForm) root.parentNode.insertBefore(qForm, root.nextSibling);
      document.querySelectorAll('.nr-calc-only').forEach(function (el) { el.hidden = false; });
    }

    function setRug() {
      rug = rugs[rs.value] || null;
      fin.innerHTML = '';
      if (thumb) { thumb.hidden = !(rug && rug.i); if (rug && rug.i) { thumb.src = rug.i; thumb.alt = rug.t; } }
      if (!rug) { fin.disabled = true; fin.innerHTML = '<option>Choose a rug first</option>'; wantFin = null; if (viewWrap) viewWrap.hidden = true; return; }
      rug.f.forEach(function (v) { var o = document.createElement('option'); o.value = v; o.textContent = v; fin.appendChild(o); });
      fin.disabled = false;
      wantFin = fin.value;
      if (view) { view.href = rug.u; viewWrap.hidden = false; }
      var sl = root.querySelector('[data-sample-link]');
      if (sl) sl.href = '/pages/sample-request?rug=' + encodeURIComponent(rug.t);
    }

    function hasOpt(sel, v) { for (var i = 0; i < sel.options.length; i++) if (sel.options[i].value === v) return true; return false; }
    function applyCfg(c) {
      if (!c) return false;
      if (c.s && hasOpt(shape, c.s)) shape.value = c.s;
      if (c.w) w.value = c.w;
      if (c.l) l.value = c.l;
      if (c.c && hasOpt(care, c.c)) care.value = c.c;
      if (c.f && hasOpt(fin, c.f)) { fin.value = c.f; wantFin = c.f; }
      return true;
    }

    function sizeText(W, L) {
      W = Math.round(W); L = Math.round(L);
      return shape.value === 'round' ? W + ' cm round' : W + ' ' + X + ' ' + L + ' cm';
    }

    function showFinInfo(tile) {
      if (!finInfo) return;
      var info = !tile && rug ? finishInfo(fin.value, root) : null;
      finInfo.hidden = !info;
      if (!info) return;
      var img = finInfo.querySelector('img'), p = finInfo.querySelector('p');
      if (img) { img.hidden = !info.i; if (info.i) { img.src = info.i; img.alt = fin.value; } }
      if (p) p.textContent = info.d;
    }

    function calc() {
      cur = null; if (btn) btn.disabled = true; qOpen.disabled = true; out.hidden = true;
      var round = shape.value === 'round';
      lWrap.hidden = round;
      wLab.textContent = round ? 'Diameter (cm)' : 'Width (cm)';
      var tile = rug && rug.s ? rug.s : 0;
      if (finWrap) finWrap.hidden = !!tile;
      if (shapeWrap) shapeWrap.hidden = !!tile;
      if (tile && round) { shape.value = 'rect'; round = false; lWrap.hidden = false; wLab.textContent = 'Width (cm)'; }
      w.step = l.step = tile || 1;
      if (!rug) { msg.textContent = 'Choose a rug and enter your size to see your price.'; showFinInfo(0); return; }
      var W = parseFloat(w.value), L = round ? W : parseFloat(l.value), snapped = false;
      if (tile && W > 0 && L > 0) {
        var W2 = Math.max(tile, Math.round(W / tile) * tile), L2 = Math.max(tile, Math.round(L / tile) * tile);
        snapped = W2 !== W || L2 !== L; W = W2; L = L2;
      }
      var s = Math.min(W, L), g = Math.max(W, L);
      /* Only treat it as a runner once the size is a real rug size, so half-typed
         numbers (e.g. "4" on the way to "450") don't knock out the customer's finish. */
      var runner = !round && s >= MIN_SHORT && g >= MIN_LONG && s <= 100 && g >= 250;
      var opts = fin.options, i, swapped = null;
      for (i = 0; i < opts.length; i++) opts[i].disabled = runner && folded(opts[i].value);
      if (!tile && opts.length && wantFin) {
        var ok = false;
        for (i = 0; i < opts.length; i++) if (opts[i].value === wantFin && !opts[i].disabled) { fin.selectedIndex = i; ok = true; break; }
        if (!ok) {
          for (i = 0; i < opts.length; i++) if (!opts[i].disabled) { fin.selectedIndex = i; break; }
          swapped = wantFin;
        }
      }
      if (finWrap) finWrap.classList.toggle('nr-calc__changed', !!swapped);
      showFinInfo(tile);
      var p = price(rug.r, shape.value, W, L, tile ? '' : fin.value);
      if (p.err === 'size') { msg.textContent = 'Enter your size to see your price.'; return; }
      if (p.err === 'min') {
        msg.textContent = round ? 'The smallest round rug we make is 80 cm across.' : 'The smallest we make is 60 ' + X + ' 80 cm.';
        return;
      }
      var co = care.selectedOptions[0], perm2 = parseFloat(co.dataset.perm2) || 0;
      var add = perm2 ? Math.ceil(Math.round(p.area * perm2 * 1e6) / 1e6 / 5) * 5 : (parseFloat(co.dataset.add) || 0);
      var total = p.rug + add;
      var careLabel = care.value === 'None' ? 'None' : care.value + ' (' + money(add) + ')';
      var quoteOnly = !trade && (total > P_MAX || total < P_MIN);
      cur = { total: total, quoteOnly: quoteOnly, size: sizeText(W, L), W: Math.round(W), L: Math.round(L), seams: p.seams, shape: round ? 'Round' : (p.runner ? 'Runner' : 'Rectangle'), care: careLabel };
      var sel = '<small class="nr-calc__sel">' + esc(rug.t) + ' &middot; ' + esc(cur.size) + ' &middot; ' + esc(finishVal()) + (add ? ' &middot; ' + esc(care.value) : '') + '</small>';
      if (trade) {
        cur.tradeRug = Math.round(p.rug * (1 - tradeOff / 100));
        cur.trade = cur.tradeRug + add;
        out.innerHTML = 'Trade ' + money(cur.trade) + ' <small class="nr-calc__rrp">RRP ' + money(total) + '</small>' + sel;
      } else out.innerHTML = money(total) + sel;
      out.hidden = false; if (btn) btn.disabled = quoteOnly; qOpen.disabled = false;
      var t = trade ? 'Trade price: ' + tradeOff + '% off the rug, including GST and free delivery.' : (p.runner ? 'Custom runner, including GST and free delivery.' : 'Your custom rug price, including GST and free delivery.');
      if (swapped) t += ' ' + swapped + ' isn’t available on runners (rugs 100 cm wide or less and 250 cm or longer), so we’ve changed the finish to ' + fin.value + '. Choose a wider size and we’ll switch back to ' + swapped + ', or pick another finish.';
      else if (p.runner) t += ' Folded edge isn’t available on runners.';
      if (tile) t += ' ' + (snapped ? 'These come in ' + tile + ' ' + X + ' ' + tile + ' cm squares, so we’ve priced the nearest size: ' + cur.size + '.' : 'Made from ' + (W / tile) * (L / tile) + ' squares of ' + tile + ' ' + X + ' ' + tile + ' cm.');
      if (perm2) t += ' Includes Fabric Protection (' + money(add) + ').';
      if (p.seams) t += ' This size is hand joined' + (p.seams > 1 ? ' (' + p.seams + ' joins)' : '') + '.';
      if (quoteOnly) t += ' For a rug this size, please use “Email me this quote” and we’ll confirm the details with you before you order.';
      msg.textContent = t;
      lsSet({ rug: rug.t, u: rug.u, s: shape.value, w: cur.W, l: round ? '' : cur.L, f: tile ? '' : fin.value, c: care.value });
      if (!shownPrice) { shownPrice = true; track('nr_calc_price', { rug: rug.t, value: total }); }
    }

    function editUrl() {
      var c = { s: shape.value, w: cur.W, l: shape.value === 'round' ? '' : cur.L, f: rug.s ? '' : fin.value, c: care.value };
      return rug.u + (rug.u.indexOf('?') === -1 ? '?' : '&') + 'nrc=' + encodeURIComponent(JSON.stringify(c));
    }

    function quoteText() {
      return 'Custom rug quote\nRug: ' + rug.t + '\nShape: ' + cur.shape + '\nSize: ' + cur.size + ' (made within 2 cm)\nFinish: ' + finishVal() +
        '\nCare: ' + cur.care + '\nJoins: ' + cur.seams + (trade ? '\nTRADE price: ' + money(cur.trade) + ' incl. GST, free delivery (' + tradeOff + '% off rug; RRP ' + money(cur.total) + ')' : '\nPrice: ' + money(cur.total) + ' incl. GST, free delivery') +
        '\nTiming: ' + LEAD + '\nPrice or change this rug: ' + location.origin + editUrl();
    }

    if (rs) rs.addEventListener('change', function () { setRug(); calc(); });
    [w, l].forEach(function (e) { e.addEventListener('input', calc); });
    fin.addEventListener('change', function () { wantFin = fin.value; calc(); });
    [shape, care].forEach(function (e) { e.addEventListener('change', calc); });
    var sLink = root.querySelector('[data-sample-link]');
    if (sLink) sLink.addEventListener('click', function () { track('nr_calc_samples', { rug: rug ? rug.t : '' }); });
    root.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.tagName === 'INPUT') e.preventDefault(); });

    if (btn) btn.addEventListener('click', function () {
      if (!cur || cur.quoteOnly) return;
      var snap = cur;
      btn.disabled = true; btn.textContent = 'Adding…';
      var props = {
        'Rug': rug.t, 'Shape': snap.shape, 'Size': snap.size, 'Finish': finishVal(), 'Care': snap.care,
        'Joins': String(snap.seams), 'Price': money(snap.total) + ' incl. GST, free delivery', 'Size tolerance': 'Made within 2 cm of this size',
        'Lead time': LEAD,
        '_img': rug.i || '', '_url': rug.u || '', '_edit': editUrl()
      };
      track('nr_calc_add_to_cart', { rug: rug.t, value: snap.total, currency: 'AUD' });
      priceVariant(snap.total).then(function (id) {
        return fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: props }] })
        });
      }).then(function (r) { if (!r.ok) throw r; window.location.href = '/cart'; })
        .catch(function () { btn.disabled = false; btn.textContent = 'Add custom rug to cart'; msg.textContent = 'Sorry, that didn’t add to your cart. Please try again, or use “Email me this quote” and we’ll help.'; });
    });

    var cameFromQuote = false;
    if (qForm) {
      qForm.classList.add('nr-quote--closed');
      qOpen.addEventListener('click', function () {
        if (!cur) return;
        qForm.classList.remove('nr-quote--closed');
        var em = qForm.querySelector('input[type=email]'); if (em) em.focus();
      });
      qForm.addEventListener('submit', function () {
        if (!cur) return;
        qForm.querySelector('[data-quote-body]').value = quoteText();
        track('nr_calc_quote_request', { rug: rug.t, value: cur.total });
      });
      if (/[?&]contact_posted=true/.test(location.search) && (location.hash === '#' + root.dataset.uid || document.querySelectorAll('[data-nr-calc]').length === 1)) {
        cameFromQuote = true;
        qDone.hidden = false; qForm.classList.add('nr-quote--closed');
        if (setMode) setMode(true);
        root.scrollIntoView({ block: 'center' });
      }
    }

    /* Bring back a configuration: from an "Edit" link in the cart or a quote email,
       or the customer's last configuration of this rug. */
    var cfg = urlCfg(), restored = false;
    if (mode === 'product') {
      if (cfg) { restored = applyCfg(cfg); if (setMode) setMode(true); }
      else { var last = lsGet(); if (last && last.rug === rug.t) restored = applyCfg(last); }
    } else if (mode === 'page') {
      var src = cfg || lsGet();
      if (src && src.rug) {
        for (var k = 0; k < rugs.length; k++) if (rugs[k].t === src.rug) { rs.value = k; setRug(); restored = applyCfg(src); break; }
      }
    }
    calc();
    if (cfg && restored && !cameFromQuote) root.scrollIntoView({ block: 'center' });
  }

  /* "Shipping calculated at checkout" contradicts the calculator for custom rugs. */
  function fixShippingNote(scope, total) {
    if (total < 150) return;
    (scope || document).querySelectorAll('small, p, .ajaxcart__note').forEach(function (el) {
      if (el.__nrShip || el.children.length > 1) return;
      if (/shipping/i.test(el.textContent) && /checkout/i.test(el.textContent)) {
        el.__nrShip = true;
        el.textContent = 'GST included · Free delivery Australia-wide';
      }
    });
  }

  /* Cart drawer: show a custom rug as one line, with its photo and no quantity box. */
  function fixDrawer(container) {
    var hasCustom = false;
    container.querySelectorAll('.ajaxcart__product').forEach(function (row) {
      var link = row.querySelector('a[href*="/products/custom-rug"]');
      if (!link || row.__nr) return;
      hasCustom = true; row.__nr = true;
      var props = {};
      row.querySelectorAll('.ajaxcart__product-meta').forEach(function (m) {
        var t = m.textContent.trim();
        if (t.indexOf(':') === -1) { if (/^\$[\d,]+$/.test(t)) m.remove(); return; } /* hide the "$660" price-option label */
        var k = t.split(':')[0].trim();
        props[k] = t.slice(t.indexOf(':') + 1).trim();
        if (k.charAt(0) === '_') m.remove();
      });
      var name = row.querySelector('.ajaxcart__product-name');
      if (name && props.Rug) name.textContent = 'Custom ' + props.Rug;
      if (props._url) row.querySelectorAll('a[href*="/products/custom-rug"]').forEach(function (a) { a.href = props._url; });
      var img = row.querySelector('.ajaxcart__product-image img');
      if (img && props._img) img.src = props._img;
      var q = row.querySelector('.js-qty__wrapper');
      if (q) { q.style.display = 'none'; var one = document.createElement('span'); one.textContent = 'Qty 1 (made to order)'; one.className = 'ajaxcart__product-meta'; q.parentNode.appendChild(one); }
    });
    if (hasCustom) fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { fixShippingNote(container, c.total_price / 100); }).catch(function () {});
  }

  /* Cart page: same treatment, using /cart.js for the hidden details. */
  function fixCartPage() {
    var form = document.querySelector('form.cart');
    if (!form || !window.fetch) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var anyCustom = false;
      cart.items.forEach(function (it, idx) {
        if (!isCustomHandle(it.handle)) return;
        anyCustom = true;
        var input = form.querySelector('.cart__product-qty[data-id="' + it.key + '"]');
        if (!input) return;
        var row = input.closest('.cart__row'); if (!row || row.__nr) return; row.__nr = true;
        var pr = it.properties || {};
        input.type = 'hidden';
        var one = document.createElement('span'); one.textContent = String(it.quantity); input.parentNode.appendChild(one);
        var line = money(it.final_line_price / 100);
        var cells = row.querySelectorAll('.cart__price');
        if (cells.length) cells[0].textContent = line;
        var vm = row.querySelector('.cart__variant-meta'); if (vm) vm.remove();
        var name = row.querySelector('.cart__product-name');
        if (name && pr.Rug) name.textContent = 'Custom ' + pr.Rug;
        if (pr._url) row.querySelectorAll('a[href*="/products/custom-rug"]').forEach(function (a) { a.href = pr._url; });
        var img = row.querySelector('.cart__image img');
        if (img && pr._img) { img.classList.remove('lazyload'); img.removeAttribute('data-srcset'); img.removeAttribute('data-widths'); img.setAttribute('data-src', pr._img); img.src = pr._img; }
        var note = document.createElement('div'); note.className = 'cart__product-meta nr-cart-note';
        note.innerHTML = '<strong>GST included &middot; Free delivery</strong><br>Made to order, so custom rugs can’t be returned for change of mind.';
        if (name) name.parentNode.insertBefore(note, name.nextSibling.nextSibling || null);
        if (pr._edit) {
          var ed = document.createElement('a');
          ed.href = pr._edit; ed.className = 'btn btn--secondary btn--small nr-cart-edit';
          ed.textContent = 'Change size or finish';
          ed.addEventListener('click', function (e) {
            /* Take this rug out of the cart, then reopen the calculator with it filled in. */
            e.preventDefault();
            fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ line: idx + 1, quantity: 0 }) })
              .then(function () { location.href = pr._edit; }, function () { location.href = pr._edit; });
          });
          var rm = row.querySelector('a[href*="quantity=0"]');
          if (rm && rm.parentNode) rm.parentNode.insertBefore(ed, rm);
        }
      });
      if (anyCustom) fixShippingNote(form, cart.total_price / 100);
    }).catch(function () {});
  }

  function start() {
    fixCartPage();
    document.querySelectorAll('[data-nr-calc]').forEach(init);
    var cc = document.getElementById('CartContainer');
    if (cc && window.MutationObserver) {
      fixDrawer(cc);
      new MutationObserver(function () { fixDrawer(cc); }).observe(cc, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('quickshop:opened', function () { setTimeout(function () { document.querySelectorAll('[data-nr-calc]').forEach(init); }, 50); });
})();
